import Vue from 'vue'

export default {
  login (username, password, cb, errorCb) {
    return Vue.http.get('zoolanders/login', { username, password })
      .then(({ data }) => cb(data), response => errorCb(response))
  },
  logout (cb, errorCb) {
    return Vue.http.get('zoolanders/logout')
      .then(cb, response => errorCb(response))
  }
}



/** WEBPACK FOOTER **
 ** ./src/api/authentication.js
 **/